var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8370_42707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1827 0H5.50283C2.4637 0 0 2.4637 0 5.50283V31.1827C0 34.2218 2.4637 36.6855 5.50283 36.6855H31.1827C34.2218 36.6855 36.6855 34.2218 36.6855 31.1827V5.50283C36.6855 2.4637 34.2218 0 31.1827 0Z",
    fill: "#0741AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6671 25.5795C31.2403 25.7228 31.7418 25.4362 32.0284 25.0063C32.1717 24.7913 32.1717 24.4331 32.1717 23.6449V12.8256C32.1717 12.0374 32.1717 11.7508 32.0284 11.4642C31.8135 10.891 31.2403 10.676 30.6671 10.891C29.1624 11.8941 25.8664 14.8318 25.7948 16.0499C25.7374 16.2648 25.7374 16.6231 25.7374 17.1246V19.8474C25.7374 20.4206 25.7374 20.6356 25.7948 20.9222C25.8664 21.4954 26.0814 21.9969 26.368 22.2835C27.2278 22.9284 30.0939 25.5079 30.7387 25.5079L30.6671 25.5795ZM4.58594 13.3988C4.58594 12.324 4.58594 11.7508 4.80089 11.4642C4.94419 11.1776 5.3741 10.891 5.58906 10.676C5.87566 10.4611 6.37722 10.4611 7.52365 10.4611H16.7667C19.4894 10.4611 20.8508 10.4611 21.9256 11.0343C22.7138 11.6075 23.5736 12.109 24.0751 13.1838C24.6483 14.2586 24.6483 15.62 24.6483 18.3427V23.215C24.6483 24.2898 24.6483 24.863 24.4334 25.1496C24.2901 25.4362 23.8602 25.7228 23.6452 25.9378C23.3586 26.1527 22.8571 26.1527 21.7106 26.1527H12.4676C9.74484 26.1527 8.38346 26.1527 7.30869 25.5795C6.52053 25.0063 5.66071 24.5047 5.15915 23.43C4.58594 22.3552 4.58594 20.9938 4.58594 18.2711V13.3988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8370_42707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.6855,
    height: 36.6855,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraDark);
export default __webpack_public_path__ + "static/media/camera_dark.b1eaf242.svg";
export { ForwardRef as ReactComponent };